import React, { Component } from 'react';
import Editor, { createEditorStateWithText } from 'draft-js-plugins-editor'; // eslint-disable-line import/no-unresolved
import createHashtagPlugin from 'draft-js-hashtag-plugin'; // eslint-disable-line import/no-unresolved
import { EditorState } from 'draft-js';

require.ensure([], () => {
    require('./editorStyles.less');
});

const MAX_LENGTH_TEXT = 1024;

const hashtagPlugin = createHashtagPlugin();
const plugins = [hashtagPlugin];

export default class SimpleHashtagEditor extends Component {

  state = {
    editorState: this.props.value ? createEditorStateWithText(this.props.value) : EditorState.createEmpty(),
  };

  onChange = (editorState) => {
    this.setState({
      editorState,
    });
    let description = editorState.getCurrentContent().getPlainText().trim();
    this.props.onChange(description);
  };

  _handleBeforeInput = () => {
    const currentContentLength = this.state.editorState.getCurrentContent().getPlainText().length;
    return currentContentLength >= MAX_LENGTH_TEXT ? 'handled' : 'not-handled';
  };

  _handlePastedText = (text) => {
    const currentContentLength = this.state.editorState.getCurrentContent().getPlainText().length;
    return currentContentLength + text.length > MAX_LENGTH_TEXT ? 'handled' : 'not-handled';
  };

  onEnter = (e) => {
    if (!e.nativeEvent.shiftKey)
      this.props.save();
  };

  focus = () => {
    this.editor.focus();
  };

  render() {
    return (
      <div>
        <div className="editor" onClick={this.focus}>
          <Editor
            placeholder="Description"
            editorState={this.state.editorState}
            onChange={this.onChange}
            handleBeforeInput={this._handleBeforeInput}
            handlePastedText={this._handlePastedText}
            plugins={plugins}
            onFocus={this.props.disableBinds}
            onBlur={this.props.setUpBinds}
            handleReturn={this.onEnter}
            readOnly={this.props.disabled}
            ref={(element) => { this.editor = element; }}
          />
        </div>
        <div><span>{MAX_LENGTH_TEXT - this.state.editorState.getCurrentContent().getPlainText().length}</span></div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/SimpleHashtagEditor.js
 **/